export const BASE_ERROR_MESSAGES = [
  // 'An error has ocurred updating your company information.',
  'An error has ocurred writing your contract information to our database.',
  'An error has ocurred generating your contract.',
];

export const REFERRAL_DISCOUNT = 50;
